var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:_vm.$style.img,attrs:{"src":"https://cdn.pixabay.com/photo/2019/07/29/16/13/bald-eagle-4370916__340.jpg","alt":"图片"}})}
var staticRenderFns = []

export { render, staticRenderFns }